module.exports = __webpack_public_path__ + "static/media/skyline.741f2799.svg";